import { Component, OnInit, Input } from '@angular/core';
import { PageAnchorLink } from 'src/app/data-models/common/page-achor-link.model';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-ui-header-subpage',
	templateUrl: './ui-header-subpage.component.html',
	styleUrls: ['./ui-header-subpage.component.scss']
})

export class UiHeaderSubpageComponent implements OnInit {

	@Input() title: string;
	@Input() caption: string;
	@Input() items: any[];
	@Input() textId: string;
	@Input() menu: { title: string, items: { title: string, path: string }[] }

	constructor(private logger: LoggerService) { }

	ngOnInit() {
	}

	menuItemClick(event, item) {
		try {
			const element = document.querySelector('#' + item.path) as HTMLElement;
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'center' });
				// Fix for Edge browser
				window.scrollBy(0, -60);
				// fix for VAN-12795 , focus element only when event is key press for narrator to read element text.
				// if (event.type !== 'click') {
				const focusElement = element.querySelector('[tabIndex = \'-1\']') as HTMLElement;
				if (focusElement) {
					focusElement.focus();
				}
			}
		}
		catch (error) {
			this.logger.error('UiHeaderSubpageComponent.menuItemClick ' + error);
		}
	}

}
